module.exports = __webpack_public_path__ + "media/src/public/images/mail/pretty/chart-a84bc4a0313f3d6b513feec86bbd6f1d.png";